<template>
  <div v-show="show">
    <header> <!-- v-show="!$route.meta.hideHeader" -->
          <div class="logo">
            <router-link  to="/visitor" :class="['logo-header', getActiveTabClass('/visitor')]">
              <img :src="$_getTranslations.logo_for_branded_projects_only_header || $_getTranslations.logo_for_branded_projects || 'static/images/logos/logo_white.svg'" @click="updateBM" alt="">
            </router-link>
          </div>
          <div class="header_right">
              <div v-if="!hideLangSelection" class="language-selector" id="languageSelector">
                  <img id="languageIcon" src="static/images/menu/language.svg"  alt="Language">
                  <i id="chevronIcon" class="fas fa-chevron-down"></i>
                  <div class="vert_sep"></div>
                  <ul class="language-dropdown">
                    <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                      <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                    </li>
                  </ul>
              </div>
            <div class="menu-toggle" id="menuToggle">
              <div class="bar1"></div>
              <div class="bar2"></div>
              <div class="bar3"></div>
            </div>
          </div>

    </header>
    <nav id="navMenu" class="nav-menu">
      <ul>
        <div class="menu_open_top">
        <li>
          <router-link to="/prizes">
            <img src="/static/images/menu/menu_item_prizes.png" alt="Menu Icon">
            <div class="flex-column">
              <div class="menu_title bold">{{ $_getTranslations.home_menu_prizes_title }}</div>
              <div class="menu_desc">{{ $_getTranslations.home_menu_prizes_description}}</div>
            </div>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </li>
        <li v-if="!hideWinners"> <!-- WINNERS -->
          <router-link to="/winners">
            <img src="/static/images/menu/menu_item_winners.png" alt="Menu Icon">
            <div class="flex-column">
              <div class="menu_title bold">{{ $_getTranslations.home_menu_winners_title }}</div>
              <div class="menu_desc">{{ $_getTranslations.home_menu_winners_description }}</div>
            </div>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </li>
        <li> <!--HOW IT WORKS -->
          <router-link to="/howItWorks">
            <img src="/static/images/menu/menu_item_how.png" alt="Menu Icon">
            <div class="flex-column">
              <div class="menu_title bold">{{ $_getTranslations.home_menu_how_it_works_title }}</div>
              <div class="menu_desc">{{ $_getTranslations.home_menu_how_it_works_description }}</div>
            </div>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/login">
            <img src="/static/images/menu/menu_item_login.png" alt="Menu Icon">
            <div class="flex-column">
              <div class="menu_title bold">{{ $_getTranslations.home_menu_login }}</div>
            </div>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </li>
        </div>
      </ul>
    </nav>
    <router-view></router-view>
    <footer>
          <div class="flex-row">
            <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_terms_and_conditions_link')" target="_blank" class="terms">{{ $_getTranslations.visitor_t_and_c }}</a>
            <div class="vert_sep"></div>
            <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_privacy_and_policy_link')" target="_blank" class="privacy">{{ $_getTranslations.visitor_privacy_policy_text }}</a>
          </div>
    </footer>
    <div class="black-overlay"></div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
    <operator-selection v-if="getSelectOperatorModalChoice()"
                        @close="toggleSelectOperatorModal(false);">
    </operator-selection>
    <subscribe-game-sms v-if="getSmsModal()" @close="setShowCustomSmsModal(false);"></subscribe-game-sms>

    <div class="row random_waves">
      <div class="col-lg-2">
        <span class="waves wave3"></span>
      </div>
      <div class="col-lg-8"></div>
      <div class="col-lg-2">
        <span class="waves wave4"></span>
      </div>
    </div>

    <div class="black-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '../../common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import operatorSelection from '@/components/home/modals/OperatorSelectionModal';
import $ from 'jquery';
import { handleLanguageDropdown, handleBurger, openCloseTab, hoverMenuItems } from '../../common/jQuery';
import SubscribeGameSms from "../home/modals/custom_modals/SubscribeGameSms";
import translationMixin from "../../common/mixins/translation";


const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'navigation-header',
  mixins: [IntegrationMixin, RegistrationFlowMixin, translationMixin],
  components: {SubscribeGameSms, simplifyRegistration, subVerifyWifi, operatorSelection },
  data() {
    return {
      isIos: false,
      operatorLogoForBrandedProject: '',
      currentTabPath: '',
      showSimpleRegistrationModal: false,
      show: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.hidePage()) vm.showPage(false);
      vm.getIntegration(to);
    });
  },
  created() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.currentTabPath = sessionStorage.getItem('visitorCurrentTabPath');
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator-footer.svg` : '';
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger();
      hoverMenuItems();
    });
    openCloseTab();
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    this.getIntegration(to);
    this.currentTabPath = to.path;
    sessionStorage.setItem('visitorCurrentTabPath', to.path);
    next();
  },
  methods: {
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapActions('profile', [
      'storeVisitorWinners',
      'storeAvailablePrizeTypes',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
      'setShowCustomSmsModal',
    ]),
    goToRegistration() {
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
    showPage(value) {
      this.show = value;
    },
    getIntegration(to) {
      if (to.path === '/') this.checkForRegisterRedirect(to);
      else this.showPage(true);
    },
    checkForRegisterRedirect(to) {
      this.getIntegrationParametersCheck()(to);
    },
    toCreditsPage() {
      this.$router.push('/credits');
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      window.location.reload();
      /*this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.facebookSDKApi().then(() => {
              this.changeCSSFile();
            });
          });
        });
      });*/
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
    updateBM() {
      $('.mobile-menu__container').removeClass('open');
      $('.mobile-menu__icon').removeClass('open');
    },
  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'hideLangSelection',
      'hidePrizePage',
      'hideWinners',
      'hideLeaderboard',
      'logoOnFooter',
      'multiOperatorInfo',
      'duelSkin',
      'isBrandedProject',
      'showCustomSmsModal',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Visitor.vue